import { useTranslation } from 'react-i18next';
import SelectMultiBatchesForm from '../form/SelectMultiBatchesForm';
import { EnhancedDialog } from 'components/enhanced';

interface ProductBatchDialogProps {
  isOpen: boolean;
  onClose: () => void;
  onSubmit: (data: unknown, expirationDate?: string) => void;
  selectedMovement: any;
  setSelectedBatchId: (batchId: string) => void;
  batchExpirationOptions: any;
}

export const ProductBatchDialogDialog = ({
  isOpen,
  onClose,
  onSubmit,
  selectedMovement,
  setSelectedBatchId,
  batchExpirationOptions
}: ProductBatchDialogProps) => {
  const { t } = useTranslation();
  const translationPrefix = 'pages.movements.unapproved';

  return (
    <EnhancedDialog
      open={isOpen}
      onClose={onClose}
      fullWidth
      maxWidth="md"
      title={t(`pages.movements.multi-batches.title`)}
      subTitle={t(`${translationPrefix}.body`, {
        batch: selectedMovement?.product_batch
      })}
      submitLabel={t(`actions.confirm`)}
      submitButtonProps={{ type: 'submit', form: 'updateBatches' }}>
      <SelectMultiBatchesForm
        movement={selectedMovement}
        setBatch={setSelectedBatchId}
        batches={batchExpirationOptions}
        onSubmit={onSubmit}
      />
    </EnhancedDialog>
  );
};

export default ProductBatchDialogDialog;
